<template>
  <div class="d-flex align-items-center justify-content-center">
    <b-input-group prepend="Rp">
      <numeral
          placeholder="Harga Minimum"
          v-model="price_down"
          :debounce="500"
      />
    </b-input-group>
    <div style="margin: 0 5px; font-size: 20px">-</div>
    <b-input-group prepend="Rp">
      <numeral
          placeholder="Harga Minimum"
          v-model="price_up"
          :debounce="500"
      />
    </b-input-group>
  </div>
</template>

<script>
import Numeral from "@/components/inputs/numeral";
export default {
  name: "range-price",
  components: {Numeral},
  data() {
    return {
      price_down: null,
      price_up: null,
    }
  },
  watch: {
    price_down(n, o) {
      if (!this.lodash.isEqual(n, o)) {
        if (this.price_up && (n < this.price_up)) this.$emit('change', `${n},${this.price_up}`)
      }
    },
    price_up(n, o) {
      if (!this.lodash.isEqual(n, o)) {
        if (this.price_down && (n > this.price_down)) this.$emit('change', `${this.price_down},${n}`)
      }
    },
  }
}
</script>

<style scoped>

</style>